import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=7b076fce&scoped=true"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=js"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=js"
import style0 from "./GoogleLoginButton.vue?vue&type=style&index=0&id=7b076fce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b076fce",
  null
  
)

export default component.exports